import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';

import DownArrow from '../components/Svg/DownArrow';

import { isPortrait } from '../utils/size';

const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    position: relative;
    padding: 12px 0;
    overflow: hidden;

    select:focus {
        outline: none;
        border: solid 1px #008eff;
    }
`;

const Select = styled.select`
    appearance: none;
    background-color: transparent;
    border-radius: 2px;
    border: solid 1px ${props => (props.fieldError ? '#ff245e' : '#f1f1ee')};
    color: ${props => (props.touched || props.value ? '#333' : '#979191')};
    ${props => props.fieldError && `color: white;`};
    font-family: Averta;
    font-size: ${() => (isPortrait() ? 16 : 14)}px;
    line-height: ${() => (isPortrait() ? 20 : 18)}px;
    height: 36px;
    overflow: hidden;
    padding: 8px;
    z-index: 0;
    outline: none;

    &:active,
    &:focus {
        outline: none;
        border: solid 1px #979191;
    }

    @media (max-width: 30em) {
        margin-left: 0;
        margin-right: 0;
    }

    &.default {
        color: #a59f9f;

        &.changed {
            color: #333;
        }
    }

    option {
        color: #333;

        &:active,
        &:focus {
            outline: none;
        }
        &:first-child {
            color: #a59f9f;
        }
    }

    + svg {
        position: absolute;
        ${props => (props.hasInfoText ? 'top: 28px;' : 'bottom: 10px;')};
        bottom: 24px;
        right: 10px;
        pointer-events: none;
        cursor: pointer;
        z-index: 2;
    }
`;

const Label = styled.label`
    ${props => !props.default && `background-color: white`};
    border-radius: 5px;
    color: ${props => (props.fieldError ? `#ff245e` : `#979191`)};
    font-family: Averta;
    font-size: ${props => (props.default ? `14px` : `8px`)};
    font-weight: ${props => (props.default ? `400` : `600`)};
    left: 5px;
    letter-spacing: 1px;
    line-height: 1.5;
    padding: 0 5px;
    pointer-events: none;
    position: absolute;
    text-transform: ${props => (props.default ? `capitalize` : `uppercase`)};
    top: ${props => (props.default ? `20px` : `6px`)};
    transition: all 250ms ease;
    white-space: nowrap;
    z-index: 2;
`;

const LabelInfo = styled(Label)`
    text-transform: none;
    letter-spacing: 0;
    margin-top: 6px;
    margin-bottom: 0;
    font-weight: 500;
    font-size: 8.5px;
    line-height: 1.4;
`;

class DropDownSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            touched: false
        };
        this.focusTextInput = this.focusTextInput.bind(this);
    }

    componentDidMount() {
        this.clearFormLevelSubmissionErrors();
        if (this.props.autoFocus) {
            this.focusTextInput();
        }
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    focusTextInput() {
        this.textInput.focus();
    }

    clearFormLevelSubmissionErrors() {
        if (typeof this.props.clearSubmitErrors === 'function' && this.props.input.name) {
            this.props.clearSubmitErrors(this.props.input.name);
        }
    }

    render() {
        const fieldError =
            this.props.submissionError ||
            (this.props.meta.invalid &&
                this.props.meta.touched &&
                !this.props.meta.active);
        const defaultState = this.props.meta.touched || this.props.input.value !== '';
        return (
            <Container>
                <Label
                    fieldError={fieldError}
                    default={!this.props.meta.valid && !this.props.meta.active}
                >
                    {fieldError
                        ? this.props.meta.error
                        : defaultState
                            ? this.props.label //eslint-disable-line
                            : null //eslint-disable-line
                    }
                </Label>
                <Select
                    className={this.props.class}
                    touched={this.props.meta.touched}
                    hasInfoText={
                        this.props.infoText !== '' && this.props.infoText !== undefined
                    }
                    onClick={() => {
                        this.clearFormLevelSubmissionErrors();
                        this.props.input.onFocus();
                    }}
                    fieldError={fieldError}
                    {...this.props.input}
                    {...this.props.meta}
                >
                    <option value="" disabled>
                        {this.props.label}
                    </option>
                    {this.props.countryCodeDropdown
                        ? this.props.options.map((option, i) => (
                              <option value={option.code} key={i}>
                                  {option.value}
                              </option>
                          ))
                        : this.props.options.map(option => (
                              <option value={option} key={option}>
                                  {option}
                              </option>
                          ))}
                </Select>
                <DownArrow />
                {this.props.infoText && <LabelInfo>{this.props.infoText}</LabelInfo>}
            </Container>
        );
    }
}

DropDownSelect.propTypes = {
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    primary: PropTypes.bool,
    autoFocus: PropTypes.bool,
    maxLength: PropTypes.number,
    autoFocusTimeout: PropTypes.number,
    placeholder: PropTypes.string,
    autocomplete: PropTypes.string,
    inputColor: PropTypes.string,
    options: PropTypes.array,
    defaultOption: PropTypes.string,
    class: PropTypes.string,
    infoText: PropTypes.string,
    countryCodeDropdown: PropTypes.bool,
    submissionError: PropTypes.bool,
    clearSubmitErrors: PropTypes.func
};

export default DropDownSelect;
